<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="طبقه‌بندی حفاظتی و مدیریت تامین کنندگان"
        description="در این بخش می‌توانید طبقه‌بندی حفاظتی شغل و تامین کنندگان را مدیریت کنید"
    />

    <div class="row mt-4">
      <div class="col-md-12">
        <ProtectionsSection/>
      </div>
      <div class="col-md-12">
        <SuppliersSection/>
      </div>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button type="button" class="btn btn-primary btn-submit-1 custom-p-2" @click="prev">
        مرحله قبل
      </button>
      <button type="submit" class="btn btn-primary btn-submit-1 custom-p-2" @click="submit">
        پایان
      </button>
    </div>
  </div>
</template>

<script>
import ProtectionsSection from "@/components/JobDescription/StepSeven/ProtectionsSection.vue";
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import SuppliersSection from "@/components/JobDescription/StepSeven/SuppliersSection.vue";
import {useToast} from "vue-toastification";

export default {
  components: {SuppliersSection, JobDescriptionHeader, ProtectionsSection},
  methods: {
    prev() {
      this.$emit("prev");
    },
    submit() {
      this.$emit("submit");
      const toast = useToast();
      toast.success('مراحل با موفقیت تکمیل شدند.');
    },
  },
};
</script>
